import { render, staticRenderFns } from "./no-deliver.vue?vue&type=template&id=72782143&scoped=true&"
import script from "./no-deliver.vue?vue&type=script&lang=js&"
export * from "./no-deliver.vue?vue&type=script&lang=js&"
import style0 from "./no-deliver.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./no-deliver.vue?vue&type=style&index=1&id=72782143&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72782143",
  null
  
)

export default component.exports